export type evaluatedString = string;

export type SelectRequestType = {
	method: 'GET' | 'POST' | 'PUT' | string;
	url: string;
	params?: Record<string, any>;
	headers?: Record<string, string | string[]>;
	body?: any;
	onSuccess?: any[];
};

export const EVENTS = {
	afterLoadItems: 'AFTER_LOAD_ITEMS',
	afterValueChange: 'AFTER_VALUE_CHANGE',
	onChange: 'ON_CHANGE',
	onSearch: 'ON_SEARCH',
	onAdd: 'ON_ADD',
	onRemove: 'ON_REMOVE',
};

export type HooksType = {
	[p in keyof typeof EVENTS]: evaluatedString;
};

export type SelectRequestOptionsType = {
	[p in keyof SelectRequestType]: evaluatedString;
};

export type SelectCustomOptionsType = {
	url?: evaluatedString;
	itemTemplate?: evaluatedString;
	groupTemplate?: evaluatedString;
	selectedTemplate?: evaluatedString;
	bindLabel?: string;
	bindGroup?: string;
	groupBy: string;
	bindValue?: string;
	multiple?: boolean;
	selectableGroup?: boolean;
	selectableGroupAsModel?: boolean;
	closeOnSelect?: boolean;
	dispatchEvents?: boolean;
	request?: SelectRequestOptionsType;
	hooks?: HooksType;
	searchFields?: string;
	hideSelected?:boolean;
};
